/**
 * The questions the agent's own clients asked about an offering and that wait for an answer
 * (17 CFR 230.502(b)(2)(v); S-30).
 */
import PageHeader from '../../components/layout/PageHeader';
import OfferingQuestionsPanel from '../../components/manager/OfferingQuestionsPanel';

export default function OfferingQuestions(): JSX.Element {
  return (
    <div className="max-w-4xl">
      <PageHeader
        title="Offering questions"
        subtitle="Questions your clients asked before buying. Answer them here; the client sees the answer."
      />
      <OfferingQuestionsPanel />
    </div>
  );
}
